export default {
  brandName: 'TermiTech',
  mainTitleLine1: 'Heterogeneous Multi-Robot',
  mainTitleLine2: 'Operations Management Platform',
  description: 'Unified scheduling and intelligent allocation for complex fleet operations.',
  featureSafe: 'Secure',
  featureStable: 'Reliable',
  featureSmart: 'Intelligent',
  welcomeTitle: 'Welcome back',
  welcomeSubtitle: 'Sign in to continue using the platform',
  usernameLabel: 'Username',
  usernamePlaceholder: 'Enter your username',
  passwordLabel: 'Password',
  passwordPlaceholder: 'Enter your password',
  submit: 'Sign In',
  submitting: 'Signing in...',
}
